import md5 from 'md5';
import { API_KEY_AES_IV } from '../constants';

function checkInt(value) {
  return parseInt(value) === value;
}

function checkInts(arrayish) {
  if (!checkInt(arrayish.length)) {
    return false;
  }

  for (var i = 0; i < arrayish.length; i++) {
    if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) {
      return false;
    }
  }

  return true;
}

function coerceArray(arg, copy) {
  // ArrayBuffer view
  if (arg.buffer && arg.name === 'Uint8Array') {
    if (copy) {
      if (arg.slice) {
        arg = arg.slice();
      } else {
        arg = Array.prototype.slice.call(arg);
      }
    }

    return arg;
  }

  // It's an array; check it is a valid representation of a byte
  if (Array.isArray(arg)) {
    if (!checkInts(arg)) {
      throw new Error('Array contains invalid value: ' + arg);
    }

    return new Uint8Array(arg);
  }

  // Something else, but behaves like an array (maybe a Buffer? Arguments?)
  if (checkInt(arg.length) && checkInts(arg)) {
    return new Uint8Array(arg);
  }

  throw new Error('unsupported array-like object');
}

export const hexToBytes = (text) => {
  var result = [];
  for (var i = 0; i < text.length; i += 2) {
    result.push(parseInt(text.substr(i, 2), 16));
  }
  return result;
};

export const utf8ToBytes = (text) => {
  var result = [],
    i = 0;
  text = encodeURI(text);
  while (i < text.length) {
    var c = text.charCodeAt(i++);

    // if it is a % sign, encode the following 2 bytes as a hex value
    if (c === 37) {
      result.push(parseInt(text.substr(i, 2), 16));
      i += 2;

      // otherwise, just the actual byte
    } else {
      result.push(c);
    }
  }

  return coerceArray(result);
};

export async function decryptNative(payload, ivBYte, keyByte) {
  let cryptoKey;
  let result;
  try {
    cryptoKey = await window.crypto.subtle.importKey('raw', keyByte, 'AES-CBC', false, ['decrypt']);
  } catch (e) {
    console.error('crypto key error', e);
  }
  if (cryptoKey) {
    try {
      result = await window.crypto.subtle.decrypt({ name: 'AES-CBC', iv: ivBYte }, cryptoKey, payload);
    } catch (e) {
      console.log('decrypt error', e);
    }
  }
  if (result) return result;
  return null;
}

export async function decryptContent(baseKey, baseIV, payload) {
  try {
    let key = hexToBytes(baseKey);
    const iv = utf8ToBytes(baseIV);
    key = new Uint8Array(key);
    const decryptedBytes = await decryptNative(payload, iv, key);
    return decryptedBytes;
  } catch (e) {
    console.error('Decrypt TS content error', e);
    return null;
  }
}

export async function decryptStateJson(eventId, encData, data) {
  try {
    if (encData && encData.mode === 2) {
      const base = encData.encBase + eventId;
      const aesKey = md5(base);
      const response = await decryptContent(aesKey, encData.iv, data);
      if (response) {
        const textResponse = String.fromCharCode.apply(null, new Uint8Array(response));
        if (textResponse) {
          return JSON.parse(textResponse);
        }
      }
      return null;
    } else {
      const textResponse = String.fromCharCode.apply(null, new Uint8Array(data));
      if (textResponse) {
        return JSON.parse(textResponse);
      }
    }
  } catch (err) {
    console.error('Decrypt state json', err);
    return null;
  }
}

async function convertBlobToBase64(imageurl) {
  return new Promise((resolve) => {
    var reader = new FileReader();
    reader.readAsDataURL(imageurl);
    reader.onloadend = function () {
      var base64data = reader.result;
      resolve(base64data);
    };
  });
}

async function generateAesKey(imageUrl) {
  const image = await fetch(imageUrl);
  const imageBlog = await image.blob();
  const aesKey = await convertBlobToBase64(imageBlog);
  return aesKey;
}

export async function decryptApiKeyJson(data, imageUrl) {
  try {
    const aesKey = await generateAesKey(imageUrl);
    const iv = API_KEY_AES_IV;
    const response = await decryptContent(md5(aesKey.split('base64,')[1]), iv, data);
    if (response) {
      const textResponse = String.fromCharCode.apply(null, new Uint8Array(response));
      if (textResponse) {
        return JSON.parse(textResponse);
      }
    }
    return null;
  } catch (err) {
    console.error('Decrypt state json', err);
    return null;
  }
}

export function encodeId(id) {
  return md5(id);
}
